export default class extends Controller {
  setSlideOutDataAttrs({ headerColor, title, contentURL, contentHTML, fullWidth }) {
    const isFullWidth = App.Helpers.isTruthy(fullWidth)
    this.slideOutComponent.setAttribute(`data-${this.slideOutDataAttrsPrefix}-header-color`, headerColor)
    this.slideOutComponent.setAttribute(`data-${this.slideOutDataAttrsPrefix}-title`, title)
    this.slideOutComponent.setAttribute(`data-${this.slideOutDataAttrsPrefix}-content-url`, contentURL)
    this.slideOutComponent.setAttribute(`data-${this.slideOutDataAttrsPrefix}-content-html`, contentHTML)
    this.slideOutComponent.setAttribute(`data-${this.slideOutDataAttrsPrefix}-full-width`, isFullWidth)
    this.slideOutComponent.setAttribute(`data-${this.slideOutDataAttrsPrefix}-slide-out-template`, this.templateHTML)
  }

  get slideOutComponent() {
    this._slideOutComponent = this._slideOutComponent || App.Helpers.getElementFromString(this.templateHTML)
    return this._slideOutComponent
  }
}



// WEBPACK FOOTER //
// ./app/components/details/assets/javascript/details-slide-out-opener-controller.js